import type {
  ISDKAdapterSetOptions,
  ISettingsParam,
  IStyleParam,
  IStyleParamValuesByType,
  SettingsParamType,
  StyleParamType,
} from '@wix/tpa-settings';
import { useSettings, useStyles } from '@wix/tpa-settings/react';
import { useExperiments } from '@wix/yoshi-flow-editor';

import { Experiment } from '../../../types';

/**
 * Rolls out the Wix Design System illustrations in every settings panel
 * thumbnail, together with the bigger thumbnail canvas they are drawn on.
 */
export const useNewThumbnailSkins = () => {
  const { experiments } = useExperiments();

  return experiments.enabled(Experiment.EnableNewThumbnailSkins);
};

export const useCascadingSettings = () => {
  const settings = useSettings();
  const styles = useStyles();

  return {
    get: <T extends SettingsParamType, U extends StyleParamType>(
      settingsParam: ISettingsParam<T>,
      styleParam: IStyleParam<U>,
    ) => {
      const valueInSettings = settings.get(settingsParam);
      const valueInStyles = styles.get(styleParam);

      return valueInStyles ?? valueInSettings;
    },
    set: <T extends StyleParamType>(
      stylesParam: IStyleParam<T>,
      value: IStyleParamValuesByType[T],
      options?: Partial<ISDKAdapterSetOptions>,
    ) => {
      return styles.set(stylesParam, value, { isGlobal: options?.isGlobal });
    },
  };
};
